import { render, staticRenderFns } from "./SearchBoxNew.vue?vue&type=template&id=2bf034c4&scoped=true&"
import script from "./SearchBoxNew.vue?vue&type=script&lang=js&"
export * from "./SearchBoxNew.vue?vue&type=script&lang=js&"
import style0 from "./SearchBoxNew.vue?vue&type=style&index=0&id=2bf034c4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bf034c4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\workspace\\uat\\platform-uat\\Platform-foundation-pc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2bf034c4')) {
      api.createRecord('2bf034c4', component.options)
    } else {
      api.reload('2bf034c4', component.options)
    }
    module.hot.accept("./SearchBoxNew.vue?vue&type=template&id=2bf034c4&scoped=true&", function () {
      api.rerender('2bf034c4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Search/SearchBoxNew.vue"
export default component.exports